import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import CustomText from "../../general/CustomText/CustomText";

const ItemsPerPageDropdown = ({
  pageSize,
  setShowDropdown,
  showDropdown,
  pageSizeOptions,
  handlePageSizeChange,
}: {
  pageSize: number;
  setShowDropdown: (show: boolean) => void;
  showDropdown: boolean;
  handlePageSizeChange: (pageSize: number) => void;
  pageSizeOptions: number[];
}) => {
  return (
    <View style={styles.container}>
      <CustomText text="items_per_page" size="s" style={{ color: "#6B7280" }} />
      <View style={{ position: "relative", zIndex: 9999 }}>
        <TouchableOpacity
          role="button"
          aria-haspopup="listbox"
          aria-expanded={showDropdown}
          accessibilityLabel={`Items per page ${pageSize}`}
          onPress={() => setShowDropdown(!showDropdown)}
          style={{
            padding: 8,
            borderRadius: 4,
            borderWidth: 1,
            borderColor: "#ccc",
            minWidth: 60,
            alignItems: "center",
          }}>
          <Text>{pageSize}</Text>
        </TouchableOpacity>

        {showDropdown && (
          <View
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              backgroundColor: "white",
              borderWidth: 1,
              borderColor: "#ccc",
              borderRadius: 4,
              zIndex: 99999,
              elevation: 10,
            }}>
            {pageSizeOptions.map((option) => (
              <TouchableOpacity
                key={option}
                role="option"
                aria-selected={pageSize === option}
                accessibilityState={{ selected: pageSize === option }}
                accessibilityLabel={`Items per page option ${option}`}
                onPress={() => handlePageSizeChange(option)}
                style={{
                  padding: 8,
                  borderBottomWidth: option !== pageSizeOptions[pageSizeOptions.length - 1] ? 1 : 0,
                  borderBottomColor: "#eee",
                }}>
                <Text style={{ textAlign: "center" }}>{option}</Text>
              </TouchableOpacity>
            ))}
          </View>
        )}
      </View>
    </View>
  );
};

export default ItemsPerPageDropdown;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginTop: 16,
  },
});
